import React from 'react';
import wechatIcon from '../asset/homeIcon/user-wechat.png';
import '../css/UserExperienceCodes.scss';

// 与静态模板用户端保持一致：微信、支付宝分别提供跑腿和外卖体验入口。
const USER_EXPERIENCE_CODES = {
  wechat: {
    name: '微信',
    icon: wechatIcon,
    codes: [
      { image: 'https://static.yiliit.com/qolai_com/home_image/blate4List/weixin_code1.png', label: '跑腿小程序' },
      { image: 'https://static.yiliit.com/qolai_com/home_image/blate4List/weixin_code2.png', label: '外卖小程序' }
    ]
  },
  alipay: {
    name: '支付宝',
    icon: 'https://static.yiliit.com/qolai_com/home_image/blate4List/alipay_icon.png',
    codes: [
      { image: 'https://static.yiliit.com/qolai_com/home_image/blate4List/alipay_code2.png', label: '跑腿小程序' },
      { image: 'https://static.yiliit.com/qolai_com/home_image/blate4List/alipay_code.png', label: '外卖小程序' }
    ]
  }
};

export default function UserExperienceCodes({ platform }) {
  const experience = USER_EXPERIENCE_CODES[platform];
  return (
    <div className="user-experience-code-card">
      {experience.codes.map(code => (
        <div className="user-experience-code-item" key={code.label}>
          <img alt={`${experience.name}${code.label}二维码`} src={code.image} className="user-experience-code-qr" />
          <div className="user-experience-code-caption">
            <img alt="" src={experience.icon} />
            <div className="user-experience-code-caption-text">
              <span className="user-experience-code-caption-title">【扫描二维码】</span>
              <span className="user-experience-code-caption-subtitle">在线体验{code.label}</span>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
